import React, {useState, useEffect} from 'react';
import CopyLink from './copyLink.js'

import {Distribution} from '../../../server/routes/route-types.js'
import {GoogleCharts} from './useGoogleCharts.js'

interface DistributionByPopularityChartProps {
	name?: string;
	distribution?: Distribution;
	google?: GoogleCharts;
	subtitle?: React.ReactNode;
	link?: string;
}

function CalculateMarketShare(techCount: number | undefined, totalCount: number): string {
	if (typeof techCount === 'undefined')
		return '0';
	if (totalCount == 0)
		return '0';
	let p = (100*techCount/totalCount);
	return p.toFixed(2);
}

function AddDataRow(data: wts_approved_any[], techCount: number, totalCount: number): void {
	let color = 'stroke-color: #703593; stroke-width: 4; fill-color: #C5A5CF';
	let percent = CalculateMarketShare(techCount, totalCount)
	data.push([totalCount, Number(percent), color, String(percent) + "%" ]);
}

export default function DistributionByPopularityChart({name, distribution, google, subtitle, link}: DistributionByPopularityChartProps) {
	if (!google) return null;
	if (!distribution) return null;
	if (!distribution.TotalCount) return null;

	const ratio = (distribution.TotalDomainCount < 1000000) ?	100 : 1;
	const c1 = Number(CalculateMarketShare(ratio*distribution.Top10KUsage, 10000));
	const c2 = Number(CalculateMarketShare(ratio*distribution.Top100KUsage, 100000));
	const c3 = Number(CalculateMarketShare(ratio*distribution.Top1MUsage, 1000000));
	const c4 = Number(CalculateMarketShare(ratio*distribution.Top10MUsage, 10000000));
	const c5 = Number(CalculateMarketShare(ratio*distribution.TotalCount, 100000000));

	// skip empty distribution chart
	if (!c1 && !c2 && !c3 && !c4 && !c5) return null;

//	console.log("Dist google="+google);

	// Fix for small DB problem (debug install)

	const [chart, setChart] = useState<wts_approved_any>(false);
//	console.log("distr chart="+chart);
	useEffect(() => {
		if (google && !chart && distribution)
		{
			const newData: wts_approved_any[] = [];

			AddDataRow(newData, ratio*distribution.Top10KUsage, 10000);
			AddDataRow(newData, ratio*distribution.Top100KUsage, 100000);
			AddDataRow(newData, ratio*distribution.Top1MUsage, 1000000);
			AddDataRow(newData, ratio*distribution.Top10MUsage, 10000000);
			AddDataRow(newData, ratio*distribution.TotalCount, 100000000);

			// Create the data table.
			const data = new google.visualization.DataTable();
			data.addColumn('number','Popularity');
			data.addColumn('number','');
			data.addColumn({type:'string', role:'style'})
			data.addColumn({type:'string', role:'annotation'})
		
			const color = 'stroke-color: #703593; stroke-width: 4; fill-color: #C5A5CF';

			newData.map(( item: wts_approved_any[] ) => {
				data.addRows([[Number(item[0]), Number(item[1]),color,String(item[3])]]);
			})
				
			// Set chart options
			const options = {
				'title': (name == undefined) ? `` : `${name} usage distribution`,
				hAxis: {
					title: 'WebSite Popularity',  
					format:'#,###',
					scaleType: 'log',
					ticks: [10000, 100000, 1000000, 10000000, 100000000]
				},
				vAxis: {
					title: 'Utilization',
					minValue: 0,
					format:"#.#'%'"
				}
			};	
			const newChart = new google.visualization.ColumnChart(document.getElementById('distribution_div'));
			newChart.draw(data, options);
			setChart(newChart);					
		} 
	}, [chart, google, distribution, name, ratio]);

	return (
		<>
			{
				name != undefined &&
            	<h3 className="text-left" id="popularity">{name} usage by website rank
				<CopyLink link={link}  anchor='popularity'/>  
				</h3>				
			}
			{
				name == undefined &&
            	<h3 className="text-left"  id="popularity">Distribution by Website Rank
				<CopyLink link={link}  anchor='popularity'/> 
				</h3>					 
			}
			{subtitle}
            <br />
            <div 
                id="distribution_div" 
				style={{width: '100%'}}  
			 />
        </>
	)
}